// ** UI
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import SvgIcon from '@mui/material/SvgIcon';

const ThinArrowUpIcon = () => (
	<SvgIcon sx={{ fontSize: 18 }} viewBox="0 0 24 24">
		<path
			d="M12 4 L12 20 M12 4 L6 10 M12 4 L18 10"
			fill="none"
			stroke="currentColor"
			strokeWidth={1.8}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</SvgIcon>
);

const BackToTopButton = () => {
	const handleClick = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				py: '32px'
			}}
		>
			<ButtonBase
				onClick={handleClick}
				aria-label="Nach oben scrollen"
				sx={(theme) => ({
					width: 135,
					height: 42,
					borderRadius: '8px',
					backgroundColor: theme.palette.primary.main,
					display: 'inline-flex',
					alignItems: 'center',
					justifyContent: 'center',
					gap: '8px',
					color: theme.palette.common.white,
					'&:hover': {
						backgroundColor: theme.palette.primary.dark
					}
				})}
			>
				<ThinArrowUpIcon />
				<Typography variant="body-md" sx={{ color: 'inherit', fontWeight: 500, lineHeight: 1 }}>
					Nach oben
				</Typography>
			</ButtonBase>
		</Box>
	);
};

export default BackToTopButton;
